import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'

export const openAdvisorMail = (advisorEmail: string, subject?: string) => {
  if (advisorEmail === 'tanguy.bocquet@yago.be') window.open(`mailto:hello@yago.be?subject=${subject}`, '_blank')
  else window.open(`mailto:${advisorEmail}?subject=${subject}`, '_blank')
}

export const initializeCio = async (instance: any) => {
  if (import.meta.env.VITE_CIO_WRITE_KEY && import.meta.env.VITE_CIO_SITE_ID) {
    const analyticsBrowser = await AnalyticsBrowser.load(
      {
        cdnURL: 'https://cdp-eu.customer.io',
        writeKey: import.meta.env.VITE_CIO_WRITE_KEY
      },
      {
        integrations: {
          'Customer.io In-App Plugin': {
            siteId: import.meta.env.VITE_CIO_SITE_ID
          }
        }
      }
    )
    const analytics = analyticsBrowser[0]

    instance.appContext.config.globalProperties.$cioanalytics = analytics

    return analytics
  }
}
